<template>
    <div>
        <form-profile-update :userInfo='userInfo' @updateUser="updateUserData" context="loginUser">
        </form-profile-update>
    </div>
</template>

<script>
    import fromProfileUpdate from "./FormProfileUpdate.vue";
    import {MY_PROFILE} from "../../../script/api";
    import {getData} from "../../../script/api-service";

    export default {
        data () {
            return {
                userInfo: null
            }
        },
        components: {
            "form-profile-update": fromProfileUpdate
        },
        methods: {
            async getUserProfile() {
                let res = await getData(MY_PROFILE);

                if (res) {
                    let masterData = res?.data?.data?.user;
                    this.userInfo = masterData || null;
                }
            },
            updateUserData(data) {
                this.userInfo = data;
            }
        },
        mounted() {
            this.getUserProfile()
        }
    }
</script>